import axios from 'axios';
class Request {
	constructor(dispatch, successFn, errorFn) {
		this.successFn = typeof successFn === 'function' ? successFn : () => {};
		this.errorFn = typeof errorFn === 'function' ? errorFn : () => {};
		this.dispatch = typeof dispatch === 'function' ? dispatch : () => {};
		this.isLogoutTriggered = false;
		this.timerId = null;
	}
	checkIfInIframe() {
		if (window.self !== window.top) {
			return true;
		} else {
			return false;
		}
	}
	/**
	 * GET axios instance and do things that are common for every request
	 */
	instance() {
		// const headers = {};
		const headers = {
			Authorization: `Bearer ${localStorage.getItem('ID Token')}`,
		};

		// if (process.env.NODE_ENV === "development") {
		//   headers.frontEnv = "local";
		// }

		const instance = axios.create({
			baseURL: '',
			headers,
		});

		return instance;
	}

	logout() {
		if (!this.isLogoutTriggered) {
			this.isLogoutTriggered = true;

			window.dispatchEvent(new Event('force-logout'));
			if (this.timerId) {
				clearTimeout(this.timerId);
			}
			// 30 seconds
			this.timerId = setTimeout(() => {
				this.isLogoutTriggered = false;
			}, 30000);
		}
	}

	/**
	 * GET Requests
	 * @param {string} url
	 * @param {object} params
	 */
	async get(url, params = {}) {
		if (this.checkIfInIframe()) return false;
		try {
			const res = await this.instance().get(url, params);
			const data = res.data ? res.data : null;
			const headers = res.headers ? res.headers : null;
			this.successFn(data, headers);
			return data;
		} catch (error) {
			// const data = error.hasOwnProperty('data') ? data : null;
			// const headers = error.hasOwnProperty('headers') ? headers : null;

			this.errorFn(error);
			if (error?.response?.status === 401) {
				this.logout();
				//window.dispatchEvent(new Event('force-logout'));
			}
			return error;
		}
	}

	/**
	 * POST Requests
	 * @param {string} url
	 * @param {object} params
	 */
	async post(url, params = {}) {
		if (this.checkIfInIframe()) return false;
		try {
			const res = await this.instance().post(url, params);
			const { data = {}, status } = res;
			this.successFn(data, status);
			return data;
		} catch (error) {
			this.errorFn(error);
			if (error?.response?.status === 401) {
				//sessionStorage.removeItem("token");
				this.logout();
			}
			return error;
		}
	}
	async delete(url, params = {}) {
		if (this.checkIfInIframe()) return false;
		try {
			const res = await this.instance().post(url, params);
			const { data = {}, status } = res;
			this.successFn(data, status);
			return data;
		} catch (error) {
			this.errorFn(error);
			if (error?.response?.status === 401) {
				//sessionStorage.removeItem("token");
				this.logout();
			}
			return error;
		}
	}
}

export default Request;
